"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AD_ELIGIBLE_PAID_STORY_IDS = void 0;
// prettier-ignore
exports.AD_ELIGIBLE_PAID_STORY_IDS = [
    104003797,
    106959201,
    107181566,
    107904993,
    1194769,
    124487516,
    124711439,
    12479590,
    145287155,
    149159543,
    151830867,
    154956639,
    161440590,
    161621291,
    18024139,
    18646750,
    187775132,
    202978042,
    205912490,
    20619442,
    206445908,
    210824164,
    223623512,
    230362493,
    233482774,
    24021854,
    245902393,
    246932902,
    254612422,
    258473997,
    273725927,
    275207471,
    287991558,
    294545538,
    297744774,
    300237069,
    300421715,
    301925150,
    302248068,
    312797047,
    313526098,
    313739483,
    319155852,
    322893134,
    327880147,
    327951731,
    328509109,
    332778242,
    335713952,
    341285933,
    341667763,
    341763054,
    342675471,
    343552604,
    345762748,
    345904534,
    345913375,
    346795666,
    347100331,
    347770078,
    347923505,
    35023230,
    351732344,
    351778437,
    353561888,
    353575254,
    353578934,
    353857613,
    354488085,
    354581247,
    354771053,
    354790457,
    356139381,
    356849122,
    356871001,
    356883020,
    357034069,
    357627229,
    358191526,
    358210036,
    358250050,
    358284457,
    358333470,
    362197910,
    362219749,
    363005447,
    363005447,
    363450851,
    364128273,
    367316032,
    369596846,
    370751612,
    370778912,
    370805290,
    372779664,
    374531939,
    377137700,
    380063665,
    386698800,
    388206999,
    389097748,
    46159699,
    674163,
    75289452,
    78713026,
    80428185,
    82040526,
    82174784,
    84105002,
    890487,
    89677983,
    90623050,
];
